var $ = require('jquery');

$(window).on('load', function() {
    toggleFormCheckBoxes();
    toggleFormRadioButtons();
    siteHeader();

    let formInterval = setInterval(function() {
        if ( $('.fsBody').length ) {
            clearInterval(formInterval);
            fsForm();
        }
    }, 250);
})

function fsForm() {
    $('.fsFieldCell input[type="checkbox"]').closest('.fsOptionLabel').addClass("checkbox-parent");
    $('.fsFieldCell input[type="radio"]').closest('.fsOptionLabel').addClass("radio-parent");
    $('.fsFieldCell hr').closest('.fsFieldCell').addClass('hr-hide');
    $('.fsFieldCell').find('.fsNumber').parent().addClass('number-parent');
}

function toggleFormCheckBoxes() {
    // var clickableItems = '.fsRowBody[fs-field-type="checkbox"] .fsOptionLabel, #fsSection66651761 > div:nth-child(2) > .fsCell > div:first-child, .hs-form-checkbox-display, .hs-form-booleancheckbox-display';
    var clickableItems = '.checkbox-parent [type="checkbox"]';
    $('body').on('click', clickableItems, function(e) {
        let parent = $(this).parent();
        let input = $(this);
        input.prop('checked', !input.prop('checked'));
        input.is(':checked') ? parent.removeClass('checked') : parent.addClass('checked');
    })
}

function toggleFormRadioButtons() {
    $('body').on('click', '.radio-parent [type="radio"]', function() {
        let parent = $(this).parent();
        parent.closest('fieldset').find('.checked').removeClass('checked');
        parent.removeClass('checked');
        $(this).is(':checked') ? parent.addClass('checked') : parent.removeClass('checked');
    })
}

$('input[type="number"').on('focus', function (e) {
    $(this).on('wheel.disableScroll', function (e) {
        e.preventDefault()
    })
})
$('input[type="number"').on('blur', function (e) {
    $(this).off('wheel.disableScroll')
})



function siteHeader() {
    $('.menu-item').on('click', function() {
        $('.site-header--megamenu-open').removeClass('site-header--megamenu-open');
    })

    $('.site-header__login-menu').on('click', function() {})
}

$('body').on('click', '.fsSubmitButton, .hs-submit input', function() {
    let headerHeight = parseFloat(getComputedStyle(document.querySelector(':root')).getPropertyValue('--header-height'));
    let alertHeight = parseFloat(getComputedStyle(document.querySelector(':root')).getPropertyValue('--alert-height'));

    setTimeout(function() {
        if( $('.fsError').length ) {
            // console.log('error message');
            $('html, body').animate({
                scrollTop: $('.fsBody').offset().top - (headerHeight + alertHeight),
            })
        }

        if( $('.submitted-message').length ) {
            // console.log( 'submitted message' );
            $('html, body').animate({
                scrollTop: $('.submitted-message').parent().offset().top - 25 - (headerHeight + alertHeight),
            })
        }
    }, 1000);
})
